import { render, staticRenderFns } from "./RansferIn.vue?vue&type=template&id=24cf9afa&scoped=true&"
import script from "./RansferIn.vue?vue&type=script&lang=js&"
export * from "./RansferIn.vue?vue&type=script&lang=js&"
import style0 from "./RansferIn.vue?vue&type=style&index=0&id=24cf9afa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf9afa",
  null
  
)

export default component.exports